class DropdownMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      active: 'is-active',
      hover: 'is-hover',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: '.shopify-section-header',
      background: '.header-background',
      topMenuItem: '.header__menu-item--top',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.list-menu-dropdown > .list-menu'
    };
    this.timeout;

    //this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener('mouseenter', this.handleMouseover.bind(this));
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;

    this.bindEvent();
    this.removeClasses();
    this.addClasses();
    this.resetBackground();
    this.animateMenu();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);

    this.header = this.header || document.querySelector(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper)
    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  addClasses() {
    const isTopLevel = this.querySelector(this.selectors.topMenuItem);

    let delay = 0;
    if (isTopLevel && !this.isHover()) {
      delay = 150;

      if (this.closest('.header--top-center') || this.closest('.header--top-left')) {
        delay = 200;
      }
    }
    this.timeout = setTimeout(() => {
      if (this.isHover()) {
        this.classList.add(this.classes.active);
      }
    }, delay);

    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);

    menus.forEach((menu) => {
      let found = false;
      const childMenus = menu.querySelectorAll('dropdown-menu');
      childMenus.forEach((element) => {
        if (element === this) {
          found = true;
          return;
        }
      });

      if (!found) menu.reset();
    });
  }

  isHover() {
    return this.header.classList.contains(this.classes.hover);
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate =  this.querySelector(this.selectors.childAnimate);
    if (childAnimate) childAnimate.classList.remove(this.classes.animate);

    clearTimeout(this.timeout);
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  animateMenu() {
    const childAnimate =  this.querySelector(this.selectors.childAnimate);
    if (childAnimate) {
      setTimeout(() => {
        childAnimate.classList.add(this.classes.animate);
      }, 150);
    }
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('dropdown-menu', DropdownMenu);

class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: '.shopify-section-header',
      background: '.header-background',
      dropdown: '.list-menu-dropdown',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.mega-menu__item, .mega-menu__promo'
    };
    this.timeout = [];

    //this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener('mouseenter', this.handleMouseover.bind(this));
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;
    
    this.bindEvent();
    this.removeClasses();
    this.addClasses();
    this.showSublist();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  handleTouchMoveOutside(ev) {
    if (!this.header) return;
    
    let target_section = ev.targetTouches[0].target.closest(this.selectors.header);
    if(!target_section || this.header.classList.contains('shopify-section-header-hidden')) {
      this.reset();
      this.resetBackground();
      
      this.header.classList.remove(this.classes.hover);
      document.removeEventListener('touchmove', this.onHeaderTouchMoveOutsideEvent);
    }
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);
    this.onHeaderTouchMoveOutsideEvent = this.onHeaderTouchMoveOutsideEvent || this.handleTouchMoveOutside.bind(this);
    
    this.header = this.header || document.querySelector(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper)
    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
    document.addEventListener('touchmove', this.onHeaderTouchMoveOutsideEvent);
  }

  showSublist() {
    const dropdown = this.querySelector(this.selectors.dropdown);
    const background = this.header.querySelector(this.selectors.background);
    background.style.setProperty('--height', this.header.clientHeight + dropdown.clientHeight + 'px');
    background.classList.add(this.classes.active);
  }

  addClasses() {
    this.classList.add(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    const delay = childAnimate.length > 5 ? 75 : 150;
    childAnimate.forEach((element, index) => {
      const timeout = setTimeout(() => {
        element.classList.add(this.classes.animate);
      }, (delay * index) + 100);
      
      this.timeout.push(timeout);
    });
    
    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);
    menus.forEach((menu) => {
      menu.reset();
    });
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    childAnimate.forEach((element) => {
      element.classList.remove(this.classes.animate);
    });
    this.timeout.forEach((timeout) => {
      clearTimeout(timeout);
    });
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('mega-menu', MegaMenu);

const whereWePlayScript = document.currentScript || document.querySelector('script[src*="menu-dropdown.js"]');
const whereWePlayStateDataCache = new Map();
const stateCityPagesAssetCache = new Map();
const WHERE_WE_PLAY_DEFERRED_STATE_TITLES = ['Australia', 'Canada'];
const WHERE_WE_PLAY_MOBILE_APPEND_STATE_TITLES = ['Washington', 'Canada', 'Australia'];
const STATE_CITY_PAGES_ASSET_NAME = 'state-city-pages-data-20260410.json';
const STATE_CITY_PAGES_ASSET_SYNC = '20260511-melbourne';

function normalizeWhereWePlayPath(value = '') {
  const normalizedValue = String(value || '').trim().replace(/\/+$/, '');
  return normalizedValue || '/';
}

function normalizeWhereWePlayKey(value = '') {
  return String(value || '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/\./g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function getWhereWePlayDeferredStateIndex(title = '') {
  const normalizedTitle = normalizeWhereWePlayKey(title);
  return WHERE_WE_PLAY_DEFERRED_STATE_TITLES.findIndex((entryTitle) => (
    normalizeWhereWePlayKey(entryTitle) === normalizedTitle
  ));
}

function compareWhereWePlayStateTitles(leftTitle = '', rightTitle = '') {
  const leftDeferredIndex = getWhereWePlayDeferredStateIndex(leftTitle);
  const rightDeferredIndex = getWhereWePlayDeferredStateIndex(rightTitle);
  const leftIsDeferred = leftDeferredIndex !== -1;
  const rightIsDeferred = rightDeferredIndex !== -1;

  if (leftIsDeferred && rightIsDeferred) {
    return leftDeferredIndex - rightDeferredIndex;
  }

  if (leftIsDeferred) return 1;
  if (rightIsDeferred) return -1;

  return String(leftTitle).localeCompare(String(rightTitle));
}

function buildWhereWePlayStateLookup(states = {}) {
  const lookup = new Map();

  Object.entries(states).forEach(([stateSlug, stateEntry]) => {
    const cityPages = Array.isArray(stateEntry?.city_pages) ? stateEntry.city_pages : [];
    if (!cityPages.length) return;

    const normalizedStateSlug = normalizeWhereWePlayKey(stateSlug);
    const normalizedTitle = normalizeWhereWePlayKey(stateEntry?.title);
    const record = {
      cityPages,
      slug: normalizedStateSlug,
      stateUrl: normalizeWhereWePlayPath(stateEntry?.state_url || cityPages[0]?.url),
      title: String(stateEntry?.title || '').trim(),
    };

    if (normalizedStateSlug) lookup.set(normalizedStateSlug, record);
    if (normalizedTitle) lookup.set(normalizedTitle, record);
  });

  return lookup;
}

function buildWhereWePlayCityItem(cityPage, currentPath) {
  const cityPath = normalizeWhereWePlayPath(cityPage?.url);
  if (!cityPath) return null;

  const item = document.createElement('li');
  const link = document.createElement('a');
  const label = document.createElement('span');

  link.href = cityPath;
  link.className = 'header__menu-item list-menu__item focus-inset sp-where-play-menu__city';
  if (cityPath === currentPath) {
    link.classList.add('list-menu__item--active');
    link.setAttribute('aria-current', 'page');
  }

  label.className = 'label';
  label.textContent = String(cityPage?.city_name || '').trim().toUpperCase();

  link.appendChild(label);
  item.appendChild(link);

  return item;
}

function buildWhereWePlayMobileCityItem(cityPage, currentPath) {
  const cityPath = normalizeWhereWePlayPath(cityPage?.url);
  if (!cityPath) return null;

  const item = document.createElement('li');
  const link = document.createElement('a');

  link.href = cityPath;
  link.className = 'menu-drawer__menu-item list-menu__item focus-inset';
  link.textContent = String(cityPage?.city_name || '').trim().toUpperCase();

  if (cityPath === currentPath) {
    link.classList.add('menu-drawer__menu-item--active');
    link.setAttribute('aria-current', 'page');
  }

  item.appendChild(link);
  return item;
}

function isWhereWePlayStateExpandable(stateEntry, cityPages) {
  if (!stateEntry) return false;

  const validCityPages = Array.isArray(cityPages) ? cityPages : [];
  if (!validCityPages.length) return false;
  if (validCityPages.length > 1) return true;

  const onlyCityPath = normalizeWhereWePlayPath(validCityPages[0]?.url);
  return onlyCityPath !== stateEntry.stateUrl;
}

function syncWhereWePlayStateLink(stateGroup, stateEntry, currentPath) {
  if (!stateGroup || !stateEntry) return;

  const stateLink = stateGroup.querySelector('.sp-where-play-menu__state');
  if (!stateLink) return;

  const statePath = normalizeWhereWePlayPath(stateEntry.stateUrl);
  const isCurrentState = statePath === currentPath;
  let stateLabel = stateLink.querySelector('.label');

  stateLink.href = stateEntry.stateUrl || '#';
  stateLink.classList.toggle('list-menu__item--active', isCurrentState);

  if (isCurrentState) {
    stateLink.setAttribute('aria-current', 'page');
  } else {
    stateLink.removeAttribute('aria-current');
  }

  if (!stateLabel) {
    stateLabel = document.createElement('span');
    stateLabel.className = 'label';
    stateLink.replaceChildren(stateLabel);
  }

  stateLabel.textContent = stateEntry.title.toUpperCase();
}

function updateWhereWePlayStateGroup(stateGroup, stateEntry, currentPath) {
  if (!stateGroup || !stateEntry) return;

  syncWhereWePlayStateLink(stateGroup, stateEntry, currentPath);

  const cityPages = stateEntry.cityPages.filter((cityPage) => (
    cityPage
    && String(cityPage.city_name || '').trim()
    && String(cityPage.url || '').trim()
  ));

  let cityList = stateGroup.querySelector('.sp-where-play-menu__cities');

  if (!isWhereWePlayStateExpandable(stateEntry, cityPages)) {
    stateGroup.classList.remove('sp-where-play-menu__state-group--has-cities');
    if (cityList) cityList.remove();
    return;
  }

  stateGroup.classList.add('sp-where-play-menu__state-group--has-cities');

  if (!cityList) {
    cityList = document.createElement('ul');
    cityList.className = 'list-menu sp-where-play-menu__cities';
    cityList.setAttribute('role', 'list');
    stateGroup.appendChild(cityList);
  }

  const cityItems = cityPages
    .map((cityPage) => buildWhereWePlayCityItem(cityPage, currentPath))
    .filter(Boolean);

  cityList.replaceChildren(...cityItems);
}

function buildWhereWePlayStateGroup(stateEntry, currentPath) {
  if (!stateEntry) return null;

  const stateGroup = document.createElement('li');
  const stateLink = document.createElement('a');
  const stateLabel = document.createElement('span');

  stateGroup.className = 'sp-where-play-menu__state-group';

  stateLink.href = stateEntry.stateUrl || '#';
  stateLink.className = 'header__menu-item list-menu__item focus-inset sp-where-play-menu__state';
  if (stateEntry.stateUrl === currentPath) {
    stateLink.classList.add('list-menu__item--active');
    stateLink.setAttribute('aria-current', 'page');
  }

  stateLabel.className = 'label';
  stateLabel.textContent = stateEntry.title.toUpperCase();

  stateLink.appendChild(stateLabel);
  stateGroup.appendChild(stateLink);
  updateWhereWePlayStateGroup(stateGroup, stateEntry, currentPath);

  return stateGroup;
}

function getWhereWePlayMobileAppendRecords(stateLookup) {
  return WHERE_WE_PLAY_MOBILE_APPEND_STATE_TITLES
    .map((title) => stateLookup.get(normalizeWhereWePlayKey(title)))
    .filter(Boolean);
}

function bindWhereWePlayMobileItemEvents(item, menu) {
  if (!item || !menu) return;

  const drawer = menu.closest('header-drawer');
  if (!drawer) return;

  item.querySelectorAll('summary').forEach((summary) => {
    if (summary.dataset.whereWePlayBound === 'true') return;
    summary.addEventListener('click', drawer.onSummaryClick.bind(drawer));
    summary.dataset.whereWePlayBound = 'true';
  });

  item.querySelectorAll('button[data-close]').forEach((button) => {
    if (button.dataset.whereWePlayBound === 'true') return;
    button.addEventListener('click', drawer.onCloseButtonClick.bind(drawer));
    button.dataset.whereWePlayBound = 'true';
  });
}

function buildWhereWePlayMobileSummaryLabel(title, templateLabel, isActiveGroup) {
  const label = document.createElement('span');
  const iconNodes = templateLabel
    ? [...templateLabel.querySelectorAll('svg')].map((icon) => icon.cloneNode(true))
    : [];

  label.className = templateLabel?.className || 'menu-drawer__menu-item list-menu__item animate-arrow focus-inset';
  label.classList.remove('menu-drawer__menu-item--active');
  if (isActiveGroup) {
    label.classList.add('menu-drawer__menu-item--active');
  }

  label.append(document.createTextNode(String(title || '').trim().toUpperCase()), ...iconNodes);
  return label;
}

function buildWhereWePlayMobileStateItem(stateEntry, currentPath, templateElements = {}) {
  if (!stateEntry) return null;

  const statePath = normalizeWhereWePlayPath(stateEntry.stateUrl);
  const cityPages = (Array.isArray(stateEntry.cityPages) ? stateEntry.cityPages : []).filter((cityPage) => (
    cityPage
    && String(cityPage.city_name || '').trim()
    && String(cityPage.url || '').trim()
  ));
  const isCurrentState = statePath === currentPath;
  const isCurrentCity = cityPages.some((cityPage) => normalizeWhereWePlayPath(cityPage.url) === currentPath);
  const isActiveGroup = isCurrentState || isCurrentCity;

  const item = document.createElement('li');

  if (!isWhereWePlayStateExpandable(stateEntry, cityPages)) {
    const link = templateElements.link?.cloneNode(true) || document.createElement('a');

    link.href = statePath || '#';
    link.className = templateElements.link?.className || 'menu-drawer__menu-item list-menu__item focus-inset';
    link.classList.remove('menu-drawer__menu-item--active');
    link.textContent = stateEntry.title.toUpperCase();

    if (isCurrentState) {
      link.classList.add('menu-drawer__menu-item--active');
      link.setAttribute('aria-current', 'page');
    } else {
      link.removeAttribute('aria-current');
    }

    item.appendChild(link);
    return item;
  }

  const details = templateElements.details?.cloneNode(true) || document.createElement('details');
  const summary = details.querySelector('summary') || document.createElement('summary');
  const summaryLabelTemplate = templateElements.summaryLabel || details.querySelector('summary > .menu-drawer__menu-item');
  const submenu = details.querySelector('.menu-drawer__submenu') || document.createElement('div');
  const topbarLink = submenu.querySelector('.menu-drawer__topbar a.menu-drawer__menu-item') || document.createElement('a');
  const cityList = submenu.querySelector('ul.menu-drawer__menu') || document.createElement('ul');

  summary.replaceChildren(buildWhereWePlayMobileSummaryLabel(stateEntry.title, summaryLabelTemplate, isActiveGroup));
  if (!summary.parentElement) {
    details.appendChild(summary);
  }

  submenu.id = `childlink-${stateEntry.slug || normalizeWhereWePlayKey(stateEntry.title)}`;
  submenu.classList.add('menu-drawer__submenu', 'motion-reduce');

  topbarLink.href = statePath || '#';
  topbarLink.classList.add('menu-drawer__menu-item');
  topbarLink.classList.remove('menu-drawer__menu-item--active');
  topbarLink.textContent = stateEntry.title.toUpperCase();

  if (isCurrentState) {
    topbarLink.classList.add('menu-drawer__menu-item--active');
    topbarLink.setAttribute('aria-current', 'page');
  } else {
    topbarLink.removeAttribute('aria-current');
  }

  cityList.className = 'menu-drawer__menu list-menu';
  cityList.setAttribute('role', 'list');
  cityList.setAttribute('tabindex', '-1');
  cityList.replaceChildren(
    ...cityPages
      .map((cityPage) => buildWhereWePlayMobileCityItem(cityPage, currentPath))
      .filter(Boolean)
  );

  if (!cityList.parentElement) {
    submenu.appendChild(cityList);
  }

  if (!submenu.parentElement) {
    details.appendChild(submenu);
  }

  details.open = isActiveGroup;
  item.appendChild(details);

  return item;
}

function reconcileWhereWePlayMobileStateItems(menu, stateLookup, currentPath, templateElements) {
  if (!menu || !stateLookup.size) return;

  [...menu.children].forEach((item) => {
    const stateText = item.querySelector(':scope > details > summary .menu-drawer__menu-item, :scope > a.menu-drawer__menu-item')?.textContent || '';
    const stateKey = normalizeWhereWePlayKey(stateText);
    if (!stateKey) return;

    const stateEntry = stateLookup.get(stateKey);
    if (!stateEntry) return;

    const nextItem = buildWhereWePlayMobileStateItem(stateEntry, currentPath, templateElements);
    if (!nextItem) return;

    bindWhereWePlayMobileItemEvents(nextItem, menu);
    item.replaceWith(nextItem);
  });
}

function getWhereWePlayStateRecords(stateLookup) {
  const records = new Map();

  stateLookup.forEach((record) => {
    if (!record?.slug || records.has(record.slug)) return;
    records.set(record.slug, record);
  });

  return [...records.values()].sort((left, right) => compareWhereWePlayStateTitles(left.title, right.title));
}

function redistributeWhereWePlayStateGroups(menu) {
  const grid = menu.querySelector('.sp-where-play-menu__grid');
  if (!grid) return;

  const columns = [...grid.querySelectorAll('.sp-where-play-menu__column')];
  if (!columns.length) return;

  const stateGroups = [...grid.querySelectorAll('.sp-where-play-menu__state-group')].sort((leftGroup, rightGroup) => {
    const leftTitle = leftGroup.querySelector('.sp-where-play-menu__state')?.textContent || '';
    const rightTitle = rightGroup.querySelector('.sp-where-play-menu__state')?.textContent || '';
    return compareWhereWePlayStateTitles(leftTitle, rightTitle);
  });

  columns.forEach((column) => column.replaceChildren());
  if (!stateGroups.length) return;

  const itemsPerColumn = Math.ceil(stateGroups.length / columns.length);

  stateGroups.forEach((stateGroup, index) => {
    const columnIndex = Math.min(Math.floor(index / itemsPerColumn), columns.length - 1);
    columns[columnIndex].appendChild(stateGroup);
  });
}

function reconcileWhereWePlayStateGroups(menu, stateLookup, currentPath) {
  const grid = menu.querySelector('.sp-where-play-menu__grid');
  if (!grid) return;

  const columns = [...grid.querySelectorAll('.sp-where-play-menu__column')];
  if (!columns.length) return;

  const getStateGroups = () => [...grid.querySelectorAll('.sp-where-play-menu__state-group')];
  const existingStateKeys = new Set(
    getStateGroups()
      .map((stateGroup) => stateGroup.querySelector('.sp-where-play-menu__state'))
      .filter(Boolean)
      .flatMap((stateLink) => [
        normalizeWhereWePlayKey(stateLink.textContent),
      ])
      .filter(Boolean)
  );

  getWhereWePlayStateRecords(stateLookup).forEach((stateEntry) => {
    const stateKey = normalizeWhereWePlayKey(stateEntry.title);
    if (existingStateKeys.has(stateKey)) return;

    const stateGroup = buildWhereWePlayStateGroup(stateEntry, currentPath);
    if (!stateGroup) return;

    const insertBefore = getStateGroups().find((group) => {
      const stateLink = group.querySelector('.sp-where-play-menu__state');
      if (!stateLink) return false;
      return compareWhereWePlayStateTitles(stateEntry.title, String(stateLink.textContent || '').trim()) < 0;
    });

    if (insertBefore?.parentElement) {
      insertBefore.parentElement.insertBefore(stateGroup, insertBefore);
    } else {
      columns[columns.length - 1].appendChild(stateGroup);
    }

    existingStateKeys.add(stateKey);
  });
}

function syncWhereWePlayDesktopMenu(menu, stateLookup) {
  if (!menu || !stateLookup.size) return;

  const currentPath = normalizeWhereWePlayPath(window.location.pathname);
  reconcileWhereWePlayStateGroups(menu, stateLookup, currentPath);

  const stateGroups = menu.querySelectorAll('.sp-where-play-menu__state-group');

  stateGroups.forEach((stateGroup) => {
    const stateLink = stateGroup.querySelector('.sp-where-play-menu__state');
    if (!stateLink) return;

    const stateKey = normalizeWhereWePlayKey(stateLink.textContent);
    const stateEntry = stateLookup.get(stateKey);
    if (!stateEntry) return;

    updateWhereWePlayStateGroup(stateGroup, stateEntry, currentPath);
  });

  redistributeWhereWePlayStateGroups(menu);
}

function syncWhereWePlayMobileMenu(menu, stateLookup) {
  if (!menu || !stateLookup.size) return;

  const currentPath = normalizeWhereWePlayPath(window.location.pathname);
  const templateDetails = menu.querySelector(':scope > li details');
  const templateLink = menu.querySelector(':scope > li > a.menu-drawer__menu-item');
  const templateSummaryLabel = templateDetails?.querySelector('summary > .menu-drawer__menu-item') || null;
  const templateElements = {
    details: templateDetails || null,
    link: templateLink || null,
    summaryLabel: templateSummaryLabel,
  };

  reconcileWhereWePlayMobileStateItems(menu, stateLookup, currentPath, templateElements);

  const existingItems = new Map(
    [...menu.children].map((item) => {
      const stateText = item.querySelector(':scope > details > summary .menu-drawer__menu-item, :scope > a.menu-drawer__menu-item')?.textContent || '';
      return [normalizeWhereWePlayKey(stateText), item];
    }).filter(([key]) => key)
  );

  getWhereWePlayMobileAppendRecords(stateLookup).forEach((stateEntry) => {
    const stateKey = normalizeWhereWePlayKey(stateEntry.title);
    const existingItem = existingItems.get(stateKey);
    if (existingItem) existingItem.remove();

    const nextItem = buildWhereWePlayMobileStateItem(stateEntry, currentPath, templateElements);
    if (!nextItem) return;

    bindWhereWePlayMobileItemEvents(nextItem, menu);
    menu.appendChild(nextItem);
  });
}

function loadWhereWePlayStateLookup(stateDataUrl = '') {
  if (!stateDataUrl) return Promise.resolve(new Map());
  if (whereWePlayStateDataCache.has(stateDataUrl)) return whereWePlayStateDataCache.get(stateDataUrl);

  const request = fetch(stateDataUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to load Where We Play state data: ${response.status}`);
      }

      return response.json();
    })
    .then((asset) => buildWhereWePlayStateLookup(asset?.states))
    .catch((error) => {
      console.warn(error);
      return new Map();
    });

  whereWePlayStateDataCache.set(stateDataUrl, request);
  return request;
}

function resolveStateCityPagesAssetUrl(explicitStateDataUrl = '') {
  const withStateCityPagesSync = (stateDataUrl) => {
    stateDataUrl.searchParams.set('sp_nav_state_sync', STATE_CITY_PAGES_ASSET_SYNC);
    return stateDataUrl.toString();
  };

  if (explicitStateDataUrl) {
    try {
      const stateDataUrl = new URL(explicitStateDataUrl, window.location.origin);
      stateDataUrl.pathname = stateDataUrl.pathname.replace(
        /state-city-pages-data(?:-\d{8})?\.json$/,
        STATE_CITY_PAGES_ASSET_NAME
      );
      return withStateCityPagesSync(stateDataUrl);
    } catch {
      return '';
    }
  }

  if (!whereWePlayScript?.src) return '';

  try {
    const stateDataUrl = new URL(whereWePlayScript.src, window.location.origin);
    stateDataUrl.pathname = stateDataUrl.pathname.replace(/menu-dropdown\.js$/, STATE_CITY_PAGES_ASSET_NAME);
    return withStateCityPagesSync(stateDataUrl);
  } catch {
    return '';
  }
}

function resolveWhereWePlayStateDataUrl(whereWePlayMenu) {
  return resolveStateCityPagesAssetUrl(whereWePlayMenu?.dataset?.stateCityPagesUrl || '');
}

function loadStateCityPagesAsset(assetUrl = '') {
  if (!assetUrl) return Promise.resolve(null);
  if (stateCityPagesAssetCache.has(assetUrl)) return stateCityPagesAssetCache.get(assetUrl);

  const request = fetch(assetUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to load state city pages asset: ${response.status}`);
      }

      return response.json();
    })
    .catch((error) => {
      console.warn(error);
      return null;
    });

  stateCityPagesAssetCache.set(assetUrl, request);
  return request;
}

function escapeStateCityPagesHtml(value = '') {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function buildStateCityPagesDescription(stateName, liveProductCount) {
  const normalizedStateName = String(stateName || '').trim();
  const normalizedCount = Number(liveProductCount) || 0;

  if (!normalizedStateName) return '';

  return `Hey ${normalizedStateName}! 👋🏻 We've got ${normalizedCount} pickleball leagues 🏓 running across ${normalizedStateName} right now. Find your city below 👇 and see venue info, maps, and local league details.`;
}

function readStateCityPagesLiveProductCount(section, fallbackCount = 0) {
  const currentValue = Number(section?.dataset?.currentLiveProductCount);
  if (Number.isFinite(currentValue)) return currentValue;

  const initialValue = Number(section?.dataset?.initialLiveProductCount);
  if (Number.isFinite(initialValue)) return initialValue;

  const fallbackValue = Number(fallbackCount);
  return Number.isFinite(fallbackValue) ? fallbackValue : 0;
}

function ensureStateCityPagesStructure(section, stateName, liveProductCount) {
  let content = section.querySelector('.sp-state-city-pages__content');
  if (!content) {
    section.innerHTML = `
      <div class="sp-state-city-pages__content">
        <div class="sp-state-city-pages__header">
          <p class="sp-state-city-pages__description"></p>
          <h2 class="sp-state-city-pages__heading"></h2>
        </div>
        <div class="sp-state-city-pages__grid"></div>
      </div>
    `;
    content = section.querySelector('.sp-state-city-pages__content');
  }

  let header = content.querySelector('.sp-state-city-pages__header');
  if (!header) {
    header = document.createElement('div');
    header.className = 'sp-state-city-pages__header';
    content.prepend(header);
  }

  let description = content.querySelector('.sp-state-city-pages__description');
  if (!description) {
    description = document.createElement('p');
    description.className = 'sp-state-city-pages__description';
    header.prepend(description);
  }

  let heading = content.querySelector('.sp-state-city-pages__heading');
  if (!heading) {
    heading = document.createElement('h2');
    heading.className = 'sp-state-city-pages__heading';
    header.append(heading);
  }

  let grid = content.querySelector('.sp-state-city-pages__grid');
  if (!grid) {
    grid = document.createElement('div');
    grid.className = 'sp-state-city-pages__grid';
    content.append(grid);
  }

  description.textContent = buildStateCityPagesDescription(stateName, liveProductCount);
  heading.textContent = `Explore Our ${stateName} Pickleball Leagues by City`;

  return { grid };
}

function buildStateCityPagesCard(cityPage) {
  const cityUrl = escapeStateCityPagesHtml(cityPage?.url || '#');
  const cityName = escapeStateCityPagesHtml(cityPage?.city_name || cityPage?.city_slug || 'City');
  const imageUrl = escapeStateCityPagesHtml(cityPage?.image_url || '');
  const imageAlt = escapeStateCityPagesHtml(cityPage?.image_alt || `${cityName} league page`);
  const badgeText = escapeStateCityPagesHtml(cityPage?.badge_text || '');
  const badgeMarkup = badgeText
    ? `<span class="sp-state-city-pages__badge">${badgeText}</span>`
    : '';
  const mediaMarkup = imageUrl
    ? `
      <span class="sp-state-city-pages__media">
        ${badgeMarkup}
        <img
          class="sp-state-city-pages__image"
          src="${imageUrl}"
          alt="${imageAlt}"
          loading="lazy"
          width="720"
          height="540"
        >
      </span>
    `.trim()
    : `
      <span class="sp-state-city-pages__media sp-state-city-pages__media--placeholder" aria-hidden="true">
        ${badgeMarkup}
      </span>
    `.trim();

  return `
    <a class="sp-state-city-pages__card" href="${cityUrl}">
      ${mediaMarkup}
      <span class="sp-state-city-pages__body">
        <span class="sp-state-city-pages__title">${cityName}</span>
        <span class="sp-state-city-pages__cta">Explore City Leagues -&gt;</span>
      </span>
    </a>
  `.trim();
}

function syncStateCityPagesSection(section, asset) {
  if (!section || !asset?.states) return;

  const stateHandle = String(section.dataset?.stateHandle || '').trim();
  const stateEntry = asset.states[stateHandle];
  const cityPages = Array.isArray(stateEntry?.city_pages) ? stateEntry.city_pages : [];
  if (!stateHandle || !cityPages.length) return;

  const stateName = String(section.dataset?.stateName || stateEntry?.title || '').trim();
  const liveProductCount = readStateCityPagesLiveProductCount(section, stateEntry?.live_product_count);
  const { grid } = ensureStateCityPagesStructure(section, stateName, liveProductCount);

  grid.innerHTML = cityPages.map((cityPage) => buildStateCityPagesCard(cityPage)).join('');
  section.dataset.currentLiveProductCount = String(liveProductCount);
}

function initializeStateCityPagesSections(root = document) {
  if (!root || typeof root.querySelectorAll !== 'function') return;

  const sections = root.querySelectorAll('.sp-state-city-pages[data-state-handle]');
  if (!sections.length) return;

  const assetUrl = resolveStateCityPagesAssetUrl(sections[0]?.dataset?.stateCityPagesUrl || '');
  if (!assetUrl) return;

  loadStateCityPagesAsset(assetUrl).then((asset) => {
    if (!asset?.states) return;
    sections.forEach((section) => syncStateCityPagesSection(section, asset));
  });
}

function initializeWhereWePlayMenuData(root = document) {
  if (!root || typeof root.querySelectorAll !== 'function') return;

  const whereWePlayMenus = root.querySelectorAll('.sp-where-play-menu');
  const whereWePlayMobileMenus = root.querySelectorAll('#link-where-we-play > .menu-drawer__inner-submenu > .menu-drawer__menu');
  if (!whereWePlayMenus.length && !whereWePlayMobileMenus.length) return;

  const stateDataUrl = resolveWhereWePlayStateDataUrl(whereWePlayMenus[0]);
  if (!stateDataUrl) return;

  loadWhereWePlayStateLookup(stateDataUrl).then((stateLookup) => {
    if (!stateLookup.size) return;
    whereWePlayMenus.forEach((menu) => syncWhereWePlayDesktopMenu(menu, stateLookup));
    whereWePlayMobileMenus.forEach((menu) => syncWhereWePlayMobileMenu(menu, stateLookup));
  });
}

function initializeStateDirectoryEnhancements(root = document) {
  initializeWhereWePlayMenuData(root);
  initializeStateCityPagesSections(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeStateDirectoryEnhancements());
} else {
  initializeStateDirectoryEnhancements();
}

document.addEventListener('shopify:section:load', (event) => initializeStateDirectoryEnhancements(event.target));
